import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  FiGrid,
  FiLayers,
  FiCalendar,
  FiUsers,
  FiUser,
  FiSettings,
  FiPlusCircle,
  FiClock,
  FiLifeBuoy,
  FiTrendingUp,
} from 'react-icons/fi'
import './Sidebar.css'

const primaryNav = [
  { path: '/', icon: FiGrid, label: 'Overview' },
  { path: '/batches', icon: FiLayers, label: 'Batches' },
  { path: '/lectures', icon: FiCalendar, label: 'Lectures' },
  { path: '/students', icon: FiUsers, label: 'Students' },
  { path: '/profile', icon: FiUser, label: 'Profile' },
  { path: '/settings', icon: FiSettings, label: 'Settings' },
]

const quickActions = [
  { path: '/lectures/new', icon: FiPlusCircle, label: 'New Lecture' },
  { path: '/lectures/schedule', icon: FiClock, label: 'Smart Scheduler' },
]

const insights = [
  { icon: FiTrendingUp, label: 'Engagement', value: '87%' },
  { icon: FiLifeBuoy, label: 'Support', value: 'Live' },
]

const Sidebar = ({ isCollapsed, isMobileOpen, onToggleCollapse, onCloseMobile }) => {
  const { user } = useSelector((state) => state.auth)

  return (
    <>
      <div
        className={`sidebar-backdrop ${isMobileOpen ? 'visible' : ''}`}
        onClick={onCloseMobile}
      />
      <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-scroll">
          <div className="sidebar-header">
            <div className="brand">
              <div className="brand-mark">
                <span>GS</span>
              </div>
              {!isCollapsed && (
                <div>
                  <p className="brand-kicker">Geekskul</p>
                  <h1 className="brand-title">Teacher Studio</h1>
                </div>
              )}
            </div>
            <button
              type="button"
              className="collapse-btn"
              aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              onClick={onToggleCollapse}
            >
              {isCollapsed ? '⟩' : '⟨'}
            </button>
          </div>

          <div className="sidebar-user">
            <div className="avatar-ring">
              <span>{user?.firstName?.[0] || 'T'}{user?.lastName?.[0] || 'P'}</span>
            </div>
            {!isCollapsed && (
              <div className="sidebar-user__details">
                <h2>{user?.firstName} {user?.lastName}</h2>
                <p>{user?.role || 'Lead Instructor'}</p>
              </div>
            )}
          </div>

          <nav className="sidebar-nav">
            <p className="sidebar-section-label">Navigate</p>
            <ul>
              {primaryNav.map((item) => {
                const Icon = item.icon
                return (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                      onClick={isMobileOpen ? onCloseMobile : undefined}
                    >
                      <span className="nav-icon">
                        <Icon size={20} />
                      </span>
                      {!isCollapsed && (
                        <span className="nav-label">{item.label}</span>
                      )}
                    </NavLink>
                  </li>
                )
              })}
            </ul>
          </nav>

          {!isCollapsed && (
            <div className="sidebar-quick">
              <p className="sidebar-section-label">Quick Actions</p>
              <div className="quick-grid">
                {quickActions.map((action) => {
                  const Icon = action.icon
                  return (
                    <NavLink key={action.path} to={action.path} className="quick-card" onClick={isMobileOpen ? onCloseMobile : undefined}>
                      <Icon size={18} />
                      <span>{action.label}</span>
                    </NavLink>
                  )
                })}
              </div>
            </div>
          )}

          {!isCollapsed && (
            <div className="sidebar-insights">
              <p className="sidebar-section-label">Today</p>
              <div className="insight-grid">
                {insights.map((item) => {
                  const Icon = item.icon
                  return (
                    <div key={item.label} className="insight-card">
                      <span className="insight-icon">
                        <Icon size={18} />
                      </span>
                      <div>
                        <p>{item.label}</p>
                        <strong>{item.value}</strong>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}

          {!isCollapsed && (
            <div className="sidebar-footer">
              <h3>Need a hand?</h3>
              <p>We&apos;re on standby to help you craft the perfect class.</p>
              <NavLink to="/settings" className="support-link" onClick={isMobileOpen ? onCloseMobile : undefined}>
                Open support desk
              </NavLink>
            </div>
          )}
        </div>
      </aside>
    </>
  )
}

export default Sidebar